/* The mockup's `.page-tabs` and `.tab`: a row of 32px links under the page header. */
.strip {
  margin-block-end: var(--space-4);
  border-block-end: 1px solid var(--border);
  padding-block-end: var(--space-2);
  overflow-x: auto;
}

.tabs {
  display: flex;
  gap: 2px;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  block-size: 32px;
  padding: 0 10px;
  border-radius: var(--radius-control);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  white-space: nowrap;
}

.tab:hover {
  background: var(--state-hover);
  color: var(--text);
}

.tab[aria-current="page"] {
  background: var(--state-active);
  color: var(--text);
}

.tab:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
